/* Marcel x Alo parity PDP (sections/ma-alo-product.liquid). Variant selection, gallery dots, sticky add-to-bag bar,
   size sheet, add to bag through /cart/add.js + the theme's CartLinesUpdateEvent (same path as assets/ma-pdp-sets.js).
   No dependencies; every feature degrades to the plain form. */
(function () {
  if (window.__mxPdp) return; window.__mxPdp = 1;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var routes = (window.Theme && Theme.routes) || {};
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  function dl(o) { try { (window.dataLayer = window.dataLayer || []).push(o); } catch (e) {} }

  async function addLine(source, id, qty) {
    qty = Math.max(1, Math.min(10, +qty || 1));
    var mod = null, def = null;
    try { mod = await import('@shopify/events'); } catch (e) { mod = null; }
    if (mod && mod.CartLinesUpdateEvent) {
      try {
        def = mod.CartLinesUpdateEvent.createPromise();
        source.dispatchEvent(new mod.CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: String(id), quantity: qty }], promise: def.promise }));
      } catch (e) { def = null; }
    }
    var body = { items: [{ id: Number(id), quantity: qty }] };
    var secs = [].map.call(document.querySelectorAll('cart-items-component'), function (n) { return n.dataset && n.dataset.sectionId; }).filter(Boolean);
    if (secs.length) body.sections = secs.join(',');
    var ok = false, json = null, cart = null;
    try {
      var res = await fetch(routes.cart_add_url || (ROOT + 'cart/add.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: JSON.stringify(body) });
      json = await res.json(); ok = res.ok && !json.status;
      try { cart = await (await fetch((routes.cart_url || (ROOT + 'cart')) + '.json', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })).json(); } catch (e2) { cart = null; }
    } catch (e) { ok = false; json = { description: 'Could not reach the bag. Try again.' }; }
    if (def) {
      if (cart) def.resolve({ cart: mod.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'mx-pdp', sourceId: 'mx-pdp', itemCount: qty, sections: json && json.sections, didError: !ok } });
      else def.reject(new Error('cart unavailable'));
    }
    return { ok: ok, json: json, events: !!def };
  }

  function init(root) {
    if (root.__mx) return; root.__mx = 1;
    var variants = [], meta = {};
    try { variants = JSON.parse(root.querySelector('[data-mx-variants]').textContent); meta = JSON.parse(root.querySelector('[data-mx-meta]').textContent); } catch (e) { return; }
    var form = root.querySelector('[data-mx-form]'), idIn = root.querySelector('[data-mx-id]');
    var accelerated = root.querySelector('[data-mx-accelerated]');
    var addBtn = root.querySelector('[data-mx-add]'), addLabel = root.querySelector('[data-mx-add-label]');
    var msg = root.querySelector('[data-mx-msg]'), priceEl = root.querySelector('[data-mx-price]');
    var bar = root.querySelector('[data-mx-bar]'), barAdd = root.querySelector('[data-mx-bar-add]'), barPrice = root.querySelector('[data-mx-bar-price]');
    var sheet = root.querySelector('[data-mx-size-sheet]');
    var opts = [].slice.call(root.querySelectorAll('[data-mx-opt]'));
    var sizeI = meta.sizeIndex;
    var colourI = meta.colourIndex != null ? meta.colourIndex : (function () { var c = root.querySelector('.mx-opt--colour'); return c ? +c.getAttribute('data-mx-opt') : -1; })();
    var single = variants.length === 1 && !opts.length;
    var conv = root.querySelector('[data-mx-conv]'), convMap = null;
    if (conv) { try { convMap = JSON.parse(conv.getAttribute('data-conv')); } catch (e) { convMap = null; } }

    // G3c: a combined size (True Notions sets: "M / L") is picked one piece at a time; the value handed to the variant match is "tee / bottom"
    function partsOf(fs) { return [].slice.call(fs.querySelectorAll('[data-mx-part]')); }
    function chosenOf(fs) {
      if (fs.hasAttribute('data-mx-split')) {
        var vals = partsOf(fs).map(function (p) { var c = p.querySelector('input:checked'); return c ? c.value : null; });
        return vals.every(Boolean) ? vals.join(' / ') : null;
      }
      var c = fs.querySelector('input:checked'); return c ? c.value : null;
    }
    function chosen() { return opts.map(chosenOf); }
    function sizeChosen() { if (sizeI < 0) return true; var fs = root.querySelector('[data-mx-size]'); return !!(fs && chosenOf(fs)); }
    function match(sel) {
      return variants.find(function (v) { return v.o.every(function (x, i) { return sel[i] == null || sel[i] === x; }); });
    }
    function current() { return single ? variants[0] : match(chosen()); }

    function paint() {
      var sel = chosen(), v = current();
      opts.forEach(function (fs, i) {
        var lab = fs.querySelector('[data-mx-optv]');
        if (lab) lab.textContent = sel[i] || '';
        if (fs.hasAttribute('data-mx-split')) {
          // per-piece rows: a chip is out when no in-stock combination has it (given the other piece, once chosen)
          var parts = partsOf(fs), pv = parts.map(function (p) { var c = p.querySelector('input:checked'); return c ? c.value : null; });
          parts.forEach(function (p, k) {
            var pl = p.querySelector('[data-mx-partv]'); if (pl) pl.textContent = pv[k] || '';
            [].forEach.call(p.querySelectorAll('input'), function (inp) {
              var want = pv.slice(); want[k] = inp.value;
              var any = variants.some(function (x) {
                if (!x.a) return false;
                var ps = String(x.o[i]).split(' / ');
                if (!want.every(function (w, q) { return w == null || ps[q] === w; })) return false;
                return x.o.every(function (y, j) { return j === i || sel[j] == null || sel[j] === y; });
              });
              var lb = inp.closest('label'); if (lb) lb.classList.toggle('is-out', !any);
            });
          });
          return;
        }
        [].forEach.call(fs.querySelectorAll('input'), function (inp) {
          var s2 = sel.slice(); s2[i] = inp.value; if (i !== sizeI && sizeI >= 0) s2[sizeI] = null;
          var any = variants.some(function (x) { return x.a && x.o.every(function (y, j) { return s2[j] == null || s2[j] === y; }); });
          var lb = inp.closest('label'); if (lb) lb.classList.toggle('is-out', !any);
        });
      });
      // shoes: the US / UK size for the EU size chosen, from the store's own conversion table
      if (conv) {
        var es = sizeI >= 0 ? sel[sizeI] : null, line = conv.getAttribute('data-default');
        if (es && convMap && convMap[es]) line = 'EU ' + es + ' = ' + convMap[es] + (convMap._l ? ' (' + convMap._l + ')' : '');
        else if (es) line = 'EU ' + es + '. See the size guide for US and UK.';
        conv.textContent = line;
      }
      // sheet buttons mirror availability
      if (sheet) [].forEach.call(sheet.querySelectorAll('[data-val]'), function (b) {
        var s2 = sel.slice(); s2[sizeI] = b.getAttribute('data-val'); var x = match(s2);
        b.classList.toggle('is-out', !(x && x.a)); b.setAttribute('aria-pressed', String(sel[sizeI] === b.getAttribute('data-val')));
      });
      if (!v) { setBtn(false, 'Unavailable'); return; }
      if (idIn && String(idIn.value) !== String(v.id)) {
        idIn.value = v.id;
        idIn.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (priceEl) priceEl.innerHTML = (v.c ? '<s class="mx-pdp__was">' + v.c + '</s> ' : '') + '<span>' + v.p + '</span>';
      if (barPrice) barPrice.textContent = v.p;
      setBtn(v.a, !v.a ? 'Sold out' : (sizeI >= 0 && !single && !sizeChosen()) ? 'Select a size' : 'Add to bag');
      if (sizeChosen() && !single) { try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u); } catch (e) {} }
    }
    function setBtn(on, label) {
      // The wallet must use an available, explicitly chosen size, like Add to bag.
      /* 15 Oct 2026 (critic round 2): the express buttons are ALWAYS visible; until a size is chosen they are dimmed with a hint, then live. */
      if (accelerated) { var ready = !!(on && sizeChosen()); accelerated.hidden = false; accelerated.classList.toggle('is-wait', !ready); accelerated.setAttribute('aria-disabled', ready ? 'false' : 'true'); }
      [addBtn, barAdd].forEach(function (b) { if (!b) return; b.disabled = !on; });
      if (addLabel) addLabel.textContent = label; if (barAdd) barAdd.textContent = label;
      root.classList.toggle('is-pick', label === 'Select a size');
    }

    // colour change: the gallery re-arranges to that colour (model first, flat second)
    opts.forEach(function (fs, i) {
      fs.addEventListener('change', function () {
        msg.textContent = '';
        if (i === colourI && gal) { gal.arrange(chosen()[colourI], true); }
        paint();
      });
    });

    // gallery
    var track = root.querySelector('[data-mx-gal-track]'), dotsWrap = root.querySelector('.mx-pdp__dots'), countEl = root.querySelector('.mx-pdp__count'), nEl = root.querySelector('[data-mx-gal-n]');
    var gal = track ? buildGallery() : null;
    function buildGallery() {
      var slides = [].slice.call(track.children).filter(function (f) { return f.hasAttribute('data-media-id'); });
      var norm = function (x) { return ' ' + String(x || '').toLowerCase().replace(/grey/g, 'gray').replace(/[^a-z0-9+]+/g, ' ').trim() + ' '; };
      var colours = [];
      if (colourI >= 0) variants.forEach(function (v) { var c = v.o[colourI]; if (c != null && colours.indexOf(c) < 0) colours.push(c); });
      var multi = colours.length > 1;
      function colourOf(f) {
        if (!multi) return '';
        var id = f.getAttribute('data-media-id'), set = {};
        variants.forEach(function (v) { if (String(v.m) === id) set[v.o[colourI]] = 1; });
        var ks = Object.keys(set), att = ks.length === 1 ? ks[0] : '';
        // the photo's own description names its colour; when it names exactly one colour it outranks the variant it happens to be attached to
        var im = f.querySelector('img'), a = norm(im && im.getAttribute('alt')), hits = [];
        colours.forEach(function (c) { var n = norm(c), i = a.indexOf(n); if (i > -1) hits.push({ c: c, i: i, len: n.length }); });
        hits = hits.filter(function (h) { return !hits.some(function (o) { return o !== h && o.len > h.len && h.i >= o.i && h.i + h.len <= o.i + o.len; }); });
        var alt = hits.length === 1 ? hits[0].c : '';
        if (att && alt && att !== alt) return alt;
        if (att) return att;
        if (ks.length > 1) return '';
        return alt;
      }
      function kindOf(f) {
        var im = f.querySelector('img'), alt = ((im && im.getAttribute('alt')) || '').toLowerCase(), src = ((im && (im.currentSrc || im.src)) || '').toLowerCase();
        if (/product photograph|vendor-ref/.test(alt + ' ' + src)) return 'v';
        // A model against limestone is still a model; the background does not make the photograph a flat lay.
        var wearer = /\b(man|woman|model)\s+(in|wearing)\b|\bworn by (a |the )?(man|woman|model)\b/.test(alt);
        if (!wearer && /laid flat|flat lay|limestone|pale limestone|, pair on|front view on|the (tee|brief|trunk|boxer brief) laid/.test(alt)) return /back view|back of the|rear view/.test(alt) ? 'b' : 'f';
        if (/close-up|macro|detail/.test(alt)) return 'd';
        if (/rear view|back view|from behind|walking away/.test(alt)) return 'mb';
        return 'm';
      }
      var info = slides.map(function (f, i) { return { f: f, i: i, c: colourOf(f), k: kindOf(f) }; });
      var isShoe = !!meta.shoe;
      // gender lead (Her / Him / Unisex arrival): the audience's own photo goes first when it is not another colour's
      var lead = null;
      (function () {
        var g = '', norm2 = function (x) { x = (x || '').toLowerCase(); return /^(her|women|womens|woman)$/.test(x) ? 'her' : /^(him|men|mens|man)$/.test(x) ? 'him' : x === 'unisex' ? 'unisex' : ''; };
        g = track.getAttribute('data-mx-gctx') || '';
        if (!g) { try { g = norm2(new URL(location.href).searchParams.get('gender')); } catch (e) {} }
        if (!g) { try { var rf = new URL(document.referrer); if (rf.host === location.host) { var mm = rf.pathname.match(/\/collections\/([^/?#]+)(?:\/([^/?#]+))?/); if (mm) { var hp = mm[1].split('-'); g = norm2(mm[2]) || norm2(hp[hp.length - 1]) || norm2(hp[0]); } } } catch (e) {} }
        if (!g) { try { g = norm2(sessionStorage.getItem('ma_g')); } catch (e) {} }
        track.__g = g; var lid = g && track.getAttribute('data-mx-lead-' + g);
        if (lid && lid !== '0') lead = info.filter(function (x) { return x.f.getAttribute('data-media-id') === lid; })[0] || null;
      })();
      var current = null, empty = null;
      function arrange(C, scroll) {
        current = C;
        var vis = info.filter(function (x) { return !multi || !C || x.c === '' || x.c === C; });
        // 14 Oct 2026 (Bruce): Unisex shows only couples / groups; Her only solo women; Him only solo men (custom.media_people: w|m|g|n)
        var gp = track.__g, offG = { unisex: { w: 1, m: 1 }, her: { m: 1 }, him: { w: 1 } }[gp];
        if (offG) vis = vis.filter(function (x) { return !offG[x.f.getAttribute('data-mx-people') || '']; });
        // Keep a colour's single photo rather than filling its gallery with other colours.
        var hide = info.filter(function (x) { return vis.indexOf(x) < 0; });
        var mine = function (x) { return !multi || x.c === C; };
        var first = function (arr) { return arr[0] || null; };
        var m0 = first(vis.filter(function (x) { return x.k === 'm' && mine(x); }));
        var um0 = first(vis.filter(function (x) { return x.k === 'm' && x.c === '' && multi; }));
        var f0 = first(vis.filter(function (x) { return x.k === 'f' && mine(x); }));
        var uf0 = first(vis.filter(function (x) { return x.k === 'f' && x.c === '' && multi; }));
        var order = [];
        function add(x) { if (x && order.indexOf(x) < 0 && vis.indexOf(x) > -1) order.push(x); }
        if (isShoe) {
          // shoes keep the curated order (a flat or an on-model lead, per the shoe rule); only another colour's photos leave
          if (lead && vis.indexOf(lead) > -1) add(lead);
          var okc = function (x) { return x && vis.indexOf(x) > -1 && (!multi || !C || x.c === '' || x.c === C); };
          if (okc(info[0])) add(info[0]); else add(f0 || m0 || um0 || uf0);
          if (okc(info[1])) add(info[1]);
        } else {
          // Phase 3 (11 Oct 2026): Shopify's own media order is the contract (#1 model, #2 flat, then the rest); only the Her / Him / Unisex lead moves up
          if (lead && vis.indexOf(lead) > -1 && lead.k === 'm') { add(lead); var sid = track.getAttribute('data-mx-second-' + (track.__g || '')); var sec = sid ? info.filter(function (x) { return x.f.getAttribute('data-media-id') === sid; })[0] : null; add(sec && vis.indexOf(sec) > -1 ? sec : (f0 || uf0)); } // 12 Oct: the flat lay always stays #2
        }
        vis.forEach(function (x) { if (x.k !== 'v') add(x); });
        vis.forEach(function (x) { add(x); });
        order.forEach(function (x) { track.appendChild(x.f); x.f.hidden = false; });
        hide.forEach(function (x) { track.appendChild(x.f); x.f.hidden = true; });
        var shown = order.length;
        if (!shown && !empty) {
          empty = document.createElement('p');
          empty.textContent = 'No photos are available for this colour.';
          empty.setAttribute('role', 'status');
          track.after(empty);
        }
        track.setAttribute('data-shown', shown);
        if (empty) empty.hidden = shown > 0;
        order.forEach(function (x, n) {
          x.f.setAttribute('aria-label', (n + 1) + ' of ' + shown);
          var im = x.f.querySelector('img'); if (im) { if (n === 0) { im.loading = 'eager'; im.setAttribute('fetchpriority', 'high'); } }
        });
        if (dotsWrap) { dotsWrap.innerHTML = ''; for (var d = 0; d < shown; d++) { var i = document.createElement('i'); if (d === 0) i.className = 'is-on'; dotsWrap.appendChild(i); } dotsWrap.hidden = shown < 2; }
        if (countEl) { countEl.hidden = shown < 2; var tot = countEl.querySelector('[data-mx-gal-t]'); if (tot) tot.textContent = shown; if (nEl) nEl.textContent = 1; }
        track.scrollLeft = 0;
        if (scroll && matchMedia('(min-width: 990px)').matches) { var r = track.getBoundingClientRect(); if (r.top < 0) window.scrollTo({ top: window.scrollY + r.top - 72, behavior: reduce ? 'auto' : 'smooth' }); }
      }
      // opening colour: the colour of the lead photo (or the photo the curated order puts first), unless the URL names a variant
      var urlVariant = null; try { urlVariant = new URL(location.href).searchParams.get('variant'); } catch (e) {}
      var c0 = '';
      if (multi) {
        var cur = chosen()[colourI];
        if (urlVariant && variants.some(function (v) { return String(v.id) === urlVariant; })) c0 = cur;
        else { var l0 = (lead && lead.c) || (info[0] && info[0].c) || ''; c0 = l0 || cur; }
        if (c0 && c0 !== cur) {
          var rad = [].filter.call(root.querySelectorAll('.mx-opt--colour input'), function (x) { return x.value === c0; })[0];
          if (rad) rad.checked = true;
        }
      }
      arrange(c0 || null, false);
      return { arrange: arrange, colour: function () { return current; } };
    }
    if (track && dotsWrap) {
      var t = 0;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(t); t = requestAnimationFrame(function () {
          var dots = dotsWrap.querySelectorAll('i'), first = track.querySelector('.mx-pdp__slide:not([hidden])');
          var sw = (first && first.getBoundingClientRect().width) || track.clientWidth; var i = Math.min(dots.length - 1, Math.round(track.scrollLeft / Math.max(1, sw)));
          [].forEach.call(dots, function (d, k) { d.classList.toggle('is-on', k === i); });
          if (nEl) nEl.textContent = i + 1;
        });
      }, { passive: true });
    }

    // size sheet
    function openSheet() { if (!sheet) return; paint(); if (sheet.showModal) sheet.showModal(); else sheet.setAttribute('open', ''); }
    if (sheet) {
      sheet.addEventListener('click', function (e) {
        var b = e.target.closest('[data-val]');
        if (b) {
          var fs = root.querySelector('[data-mx-size]');
          var inp = fs && [].find.call(fs.querySelectorAll('input'), function (x) { return x.value === b.getAttribute('data-val'); });
          if (inp) { inp.checked = true; paint(); }
          var v = current();
          if (v && v.a) { sheet.close(); submit(); }
          else msg.textContent = 'That size is sold out in this colour.';
          return;
        }
        if (e.target === sheet || e.target.closest('[data-mx-sheet-close]')) sheet.close();
      });
    }

    // quantity stepper (1 to 10)
    var qtyBox = root.querySelector('[data-mx-qty]'), qtyIn = root.querySelector('[data-mx-qty-in]'), qtyN = root.querySelector('[data-mx-qty-n]'), qty = 1;
    function setQty(n) {
      qty = Math.max(1, Math.min(10, n));
      if (qtyIn) qtyIn.value = qty; if (qtyN) qtyN.textContent = qty;
      var d = root.querySelector('[data-mx-qty-dec]'), u = root.querySelector('[data-mx-qty-inc]');
      if (d) d.disabled = qty <= 1; if (u) u.disabled = qty >= 10;
    }
    if (qtyBox) {
      qtyBox.hidden = false; setQty(1);
      qtyBox.addEventListener('click', function (e) {
        if (e.target.closest('[data-mx-qty-dec]')) setQty(qty - 1);
        else if (e.target.closest('[data-mx-qty-inc]')) setQty(qty + 1);
      });
    }

    var busy = false;
    async function submit() {
      if (busy) return;
      if (!sizeChosen()) { if (sheet && matchMedia('(max-width: 989px)').matches) { openSheet(); } else { var sp = root.querySelector('[data-mx-split]'); msg.textContent = sp ? 'Choose a size for each piece.' : 'Choose a size.'; var f = root.querySelector('[data-mx-size] input'); var tgt = f ? f.closest('fieldset') : null; if (tgt && tgt.scrollIntoView && matchMedia('(max-width: 989px)').matches) tgt.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' }); if (f) f.focus({ preventScroll: true }); } return; }
      var v = current(); if (!v || !v.a) return;
      busy = true; root.classList.add('is-busy'); setBtn(false, 'Adding');
      var r = await addLine(form, v.id, qty);
      busy = false; root.classList.remove('is-busy');
      if (r.ok) {
        setBtn(true, 'Added'); setQty(1); setTimeout(function () { paint(); }, 1600);
        dl({ event: 'add_to_cart', ecommerce: { currency: meta.currency, items: [{ item_id: meta.handle, item_variant: String(v.id), price: v.pr / 100, quantity: qty }] } });
        if (!r.events) location.href = (routes.cart_url || ROOT + 'cart');
      } else {
        paint(); msg.textContent = (r.json && (r.json.description || r.json.message)) || 'Could not add to bag. Try again.';
      }
    }
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); submit(); });
    if (barAdd) barAdd.addEventListener('click', submit);

    // sticky bar (phone): whenever the main button is not on screen, above it or still below the fold, so the way to buy is always one tap away
    if (bar && addBtn && 'IntersectionObserver' in window) {
      bar.hidden = false;
      var addSeen = false, footSeen = false;
      var sync = function () { bar.classList.toggle('is-on', !addSeen && !footSeen); };
      /* round 3: the bar covers the bottom 76px, so a main button sitting under it counts as hidden-and-needed only when it is really clear of that zone: no bar and button on screen together */
      new IntersectionObserver(function (es) { es.forEach(function (e) { addSeen = e.isIntersecting; }); sync(); }, { rootMargin: '0px 0px -76px 0px' }).observe(addBtn);
      var foot = document.querySelector('.shopify-section-group-footer-group, footer');
      if (foot) new IntersectionObserver(function (es) { es.forEach(function (e) { footSeen = e.isIntersecting; }); sync(); }).observe(foot);
    }

    // images: below-the-fold photographs on the desktop grid fade in as they arrive (first screen is never held back)
    if (track && 'IntersectionObserver' in window && !reduce && matchMedia('(min-width: 990px)').matches) {
      var late = [].filter.call(track.children, function (f) { return f.hasAttribute('data-media-id') && f.getBoundingClientRect().top > innerHeight * .9; });
      late.forEach(function (f) { f.classList.add('mx-pre'); });
      var rio = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.remove('mx-pre'); rio.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -8% 0px' });
      late.forEach(function (f) { rio.observe(f); });
    }

    paint();
    dl({ event: 'view_item', ecommerce: { currency: meta.currency, items: [{ item_id: meta.handle, item_name: meta.title }] } });
  }

  // reviews: the Judge.me widget prints an empty state at zero reviews; the whole section leaves the page instead of sitting there empty
  // (the CSS in ma-alo-pdp.css hides it first, so nothing flashes)
  function dropEmptyReviews() {
    [].forEach.call(document.querySelectorAll('.jdgm-review-widget .jdgm-empty-state'), function (e) {
      var sec = e.closest('.shopify-section'); if (sec && sec.parentNode) sec.parentNode.removeChild(sec);
    });
  }
  (function () {
    var n = 0, t = setInterval(function () { dropEmptyReviews(); if (++n > 20) clearInterval(t); }, 500);
    if ('MutationObserver' in window) { try { var mo = new MutationObserver(dropEmptyReviews); mo.observe(document.documentElement, { childList: true, subtree: true }); setTimeout(function () { mo.disconnect(); }, 12000); } catch (e) {} }
  })();

  function all() { [].forEach.call(document.querySelectorAll('[data-mx-pdp]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();


/* 16 Oct 2026: long-press on a colour swatch shows its name (touch has no hover). */
(function () {
  var t = null, tipped = null;
  function clear() { clearTimeout(t); }
  document.addEventListener('touchstart', function (e) {
    var el = e.target.closest && e.target.closest('.ma-fs__d[data-name], .mx-sw[data-name]');
    if (!el) return;
    clear();
    t = setTimeout(function () {
      if (tipped) tipped.classList.remove('is-tip');
      el.classList.add('is-tip'); tipped = el; el.setAttribute('data-ma-held', '1');
      setTimeout(function () { el.classList.remove('is-tip'); }, 1800);
    }, 380);
  }, { passive: true });
  ['touchend', 'touchmove', 'touchcancel'].forEach(function (n) { document.addEventListener(n, clear, { passive: true }); });
  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('[data-ma-held]');
    if (el) { e.preventDefault(); e.stopPropagation(); el.removeAttribute('data-ma-held'); }
  }, true);
})();


/* 16 Oct 2026: hovering or focusing a swatch previews its name in the COLOUR label; leaving restores the chosen colour. */
(function () {
  function label(el) {
    var f = el.closest('.mx-opt--colour'); if (f) return f.querySelector('[data-mx-optv], .mx-opt__v');
    return document.querySelector('.ma-fs__l span');
  }
  var saved = null, lab = null;
  function on(e) {
    var el = e.target.closest && e.target.closest('.ma-fs__d[data-name], .mx-sw[data-name]'); if (!el) return;
    lab = label(el); if (!lab) return; if (saved === null) saved = lab.textContent; lab.textContent = el.getAttribute('data-name');
  }
  function off(e) {
    var el = e.target.closest && e.target.closest('.ma-fs__d[data-name], .mx-sw[data-name]'); if (!el || !lab || saved === null) return;
    lab.textContent = saved; saved = null; lab = null;
  }
  document.addEventListener('pointerover', function (e) { if (e.pointerType !== 'touch') on(e); });
  document.addEventListener('pointerout', function (e) { if (e.pointerType !== 'touch') off(e); });
  document.addEventListener('focusin', on); document.addEventListener('focusout', off);
})();
